import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Filters from "../../../../components/Filter/filters";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import estados from "../../../../utils/_estados";
import municipios from "../../../../utils/_municipios";

class SchoolList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      filtered: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.filter = this.filter.bind(this);
    this.insertSchool = this.insertSchool.bind(this);
    this.deleteSchools = this.deleteSchools.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  insertSchool() {
    this.props.history.push("/school/form");
  }

  deleteSchools(rows) {
    const obj = {
      schools: rows
    };

    axios
      .post(`${URL.api}access/school/deleteMany`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleSchools();
        },
        () => {
          this.error("Não foi possível apagar as escolas");
        }
      );
  }

  filter(role = null, group = null, region = null, school = null) {
    this.setState({ filtered: null }, () => {
      this.setState(state => ({
        filtered: state.list.filter(
          school =>
            (!group || school.group_id === group) &&
            (!region || school.region_id === region)
        )
      }));
    });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.handleSchools();
  }

  handleSchools() {
    axios
      .get(`${URL.api}access/school/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data.map(school => ({
                      ...school,
                      city:
                        municipios.municipios.find(
                          municipio =>
                            municipio.value.toString() === school.city
                        )?.label || school.city,
                      state:
                        estados.estados.find(
                          estado => estado.value.toString() === school.state
                        )?.label || school.state
                    })),
                    loading: false
                  }),
                  () => {
                    this.filter(
                      null,
                      this.props.general.active_roles.group_id,
                      this.props.general.active_roles.region_id,
                      null
                    );
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        },
        error => {
          this.error("Não foi possível listar as escolas");
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            <Filters
              key={JSON.stringify(this.props.general.active_roles)}
              initial="group"
              type="hierarchy"
              group
              region
              action={this.filter}
            />
            {this.state.filtered ? (
              <div id="list">
                <DataTable
                  list={this.state.filtered}
                  path="/school/edit/"
                  title="Escolas"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "region_name", denomination: "Região" },
                    { name: "address", denomination: "Endereço" },
                    { name: "state", denomination: "Estado" },
                    { name: "city", denomination: "Cidade" }
                  ]}
                  insert
                  delete
                  deleteAction={this.deleteSchools}
                  insertAction={this.insertSchool}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolList);
